import { apiSlice } from "../apiSlice";

const merchantApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        updateMerchant: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/merchant/profile/update/${body.merchantId}`,
                    method: "PATCH",
                    body: body.data
                };
            },
            invalidatesTags: ['merchantList']
        }),
        deleteMerchant: builder.mutation({
            query: (id) => {
                return {
                    url: `/api/merchant/delete/${id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: ['merchantList', 'operatorList']
        }),
        getOperatorList: builder.query({
            query: (branch_id) => {
                return {
                    url: `/api/merchant/list?branch_id=${branch_id}`,
                    method: "GET",
                };
            },
            providesTags: ['operatorList']
        }),
    }),
    overrideExisting: true,
});

export const { useUpdateMerchantMutation, useGetOperatorListQuery, useDeleteMerchantMutation } = merchantApiSlice;
